export const enUS = {
  // All Pages
  addAccessories: 'Add more accessories',
  all: 'All',
  checkAll: 'Select all',
  anyFloristFounded: 'Any florist founded',
  backToOrderList: 'Back',
  cancel: 'Cancel',
  catalog: 'Catalog',
  catalogAbroad: 'Abroad product catalog',
  closed: 'Closed',
  communications: 'Communications',
  date: 'Date',
  download: 'Download',
  downloadLabel: 'Download label',
  endDate: 'End date',
  goToOrders: 'Access your orders',
  goToOrder: 'Go to order',
  history: 'History',
  hour: 'Hour',
  inProgress: 'In progress',
  isModified: 'Modified',
  isReady: 'Bouquet ready',
  ITContact: 'Interflora contact',
  loginAs: 'Logged in as',
  modify: 'Modify',
  new: 'New',
  noDocuments: 'No documents found with these filters:',
  noOrderInTab: 'No orders in this tab',
  noOrdersFound: 'No order matches this search',
  nothingFound: 'Nothing found',
  open: 'Open',
  orderDefault: 'Order',
  orders: 'Orders',
  partner: 'Partners websites',
  price: 'Price',
  startDate: 'Start date',
  suspendedFlorist: 'Florist non activ',
  to: 'to',
  and: 'and',
  today: 'Today',
  unknown: 'Unknown',
  validate: 'Validate',
  save: 'Save',
  view: 'View',
  close: 'Close',
  actionImpossible: 'Not available',
  listView: 'View list',
  listViewTooltip: 'This button displays the list',
  mapView: 'View map',
  mapViewTooltip: 'This button displays the map',
  viewOnMap: 'View on the map',
  true: 'Yes',
  false: 'No',
  delete: 'Delete',
  warning: 'Warning',
  courierDeliveryOrderWarning: 'You are acting on an order originally planned for courier delivery!',
  putOrderInProgress: 'Activating In Progress status',
  removeOrderInProgress: 'Deactivating In Progress status',
  actionUnavailable: 'Action unavailable',

  print: {
    title: 'Print',
    titleQuick: 'Quick printing',
    printed: 'Printed',
    printTooltip: "This button allows you to print the order slips that haven't been printed yet",
    printedError: 'An error occurred, please try again later.',
    printedErrorMessage: 'Some orders cannot be printed.',
    partiallyPrinted: 'Some invoices could not be printed.',
    nothingToPrint: 'No invoices to print.',
    markAsPrint: 'The order has been marked as printed.',
    markAsPrintPlural: 'The orders have been marked as printed.',
    popup: {
      title: 'Mark as printed?',
      titlePlural: 'Mark as printed?',
      validate: 'Mark as printed',
      validatePlural: 'Mark as printed',
      cancel: 'Do not mark',
      textQuickPrint: `You used quick print. Would you like to mark these orders as Printed to avoid reprinting via quick print?`,
      textMultiSelect: `You requested printing of multiple orders. Would you like to mark them as Printed to avoid reprinting via quick print?`,
      textSinglePrint: `Would you like to mark the order whose purchase order you just viewed as Printed to avoid reprinting via quick print?`,
    },
  },

  markAsPrint: {
    validMarkAsPrint: 'The orders have been marked as printed.',
    validUnmarkAsPrint: 'The orders have been marked as not printed.',
    warning: 'Some orders could not change status',
    undoMarkAsPrint: 'Remove Printed status',
    undoUnmarkAsPrint: 'Restore Printed status',
  },

  // Homepage
  message: {
    welcome: 'Welcome, {name} \ud83c\udf3b',
  },
  onboarding: {
    title: 'Tutorial',
    checkLater: 'Remind me later',
    close: 'Close',
    startGuide: 'Start',
    next: 'Next',
    finishGuide: 'Got it',
    readTime: 'Estimated time: {minutes} min',
    recipientConfirmation: {
      welcome: {
        title: "Tutorial - What's new",
        description: [
          "We've added new tools to your interface to make it easier to track your orders and deliveries. Let us guide you through how they work!",
          "What's new:",
          '1. SMS to the recipient',
          '2. Photo on delivery',
          '3. Display improvements',
        ].join('\n'),
      },
      step1: {
        title: 'Sending the SMS to the recipient',
        description: [
          'The recipient automatically receives an SMS <strong>asking them to confirm their details and that they will be available on the requested date and time slot.</strong>',
          'SMS sending: the day before delivery at 6 pm, or 30 min after purchase for same-day orders.',
          '<br />',
          'Save time: if the recipient has confirmed, no need to call them before heading out to deliver!',
          'Otherwise, carry out the delivery as you do today.',
        ].join('\n'),
      },
      step2: {
        title: 'SMS statuses',
        description: [
          'The SMS can have several statuses:',
          '1- "Validated" via SMS - everything is OK, the icon turns green',
          'Once validated, the recipient can no longer change this information.',
          '2- "Validated" by phone - You reached the recipient by phone, validate the status manually',
          '3- "Sent" - the SMS has been sent',
          '4- "Resent" - resend the SMS in one click to give the recipient a second chance to confirm.',
          '5- "Expired" - no reply 1 hour before the end of the delivery time slot, the recipient can no longer add information or validate -> carry out the delivery as you do today',
        ].join('\n'),
      },
      step3: {
        title: 'New "Ready" status',
        description: [
          'Once the product is prepared, set the order to "Ready" status in iris: you are ready to deliver it.',
          'Note: ',
          '- once the "Ready" status is set, the recipient can no longer add information',
          '- this status is available on the delivery day, from 2 hours before the start of the delivery time slot',
        ].join('\n'),
      },
      step4: {
        title: 'Order information updates',
        description: [
          'If the recipient adds details or if the order is modified, the purple "i" icon appears.',
          "Access an order's modification history in one click.",
          'Click the "i" icon from the order list to see what has changed and mark the update as seen.',
          'This information remains available at any time.',
        ].join('\n'),
      },
      step5: {
        title: 'The recipient accepts delivery in their absence',
        description: [
          'The recipient can agree to the order being left in their absence, with any additional information. E.g.: with the neighbour, in front of the door, behind the gate on the right...',
          'Find this information on the order details page or via the "i" icon',
          'In this specific case, <strong>a photo is required at the time of delivery, with no visible faces. It protects you in the event of a dispute.</strong>',
        ].join('\n'),
      },
      step6: {
        title: 'How to take the photo?',
        description:
          'When you confirm the delivery, a screen appears. Remember to scroll down using the side bar to display the PHOTO option',
      },
      step7: {
        title: 'Print tracking',
        description: 'From the order list, see at a glance whether your orders have been printed.',
      },
      step8: {
        title: 'More visible status colours',
        description:
          'The colour has been strengthened on certain areas of the order rows to better distinguish statuses, without making the rest of the row harder to read.',
      },
    },
  },
  ordersHome: {
    today: 'Orders for today',
    tomorrow: 'Orders for tomorrow',
    later: 'Orders for later',
    late: 'Late orders',
  },
  orderHome: {
    today: 'Order for today',
    tomorrow: 'Order for tomorrow',
    later: 'Order for later',
    late: 'Late order',
  },
  linkNewsLabel: 'See all news',
  seeMore: 'See more',
  seeLess: 'See less',
  seeHistory: 'see history',
  NoNotification: 'No notification',
  explanation: {
    title: 'Iris introduction',
    content: `Welcome to your new florist platform.
We want to remind you that this is not the final version, our work is still in progress. 
During this phase, your feedback is crucial.
We want to thank you in advance for your understanding and patience.`,
  },
  newCollectionHome: 'The collection of the moment',

  // Nav
  nav: {
    admin: 'My Account',
    contact: 'Contact',
    deliveries: 'Deliveries',
    history: 'History',
    home: 'Home',
    internalUser: 'Internal user',
    orders: 'Orders',
    page: 'My Shop',
    QrCode: 'Order validation',
    signOut: 'Sign Out',
    transmissions: 'Transmissions',
    faq: 'Ask questions,',
    xlFlorist: 'XL Florist',
  },

  // Orders
  details: {
    download: 'Download as PDF',
    delivered: 'Set as delivered',
    absent: 'Set as absent',
    reassign: 'Reassign',
    additional: 'Additional Information',
    accept: 'Accept',
    refuse: 'Refuse',
    addInfo: 'Add notes',
    assignToCourier: 'Assign to a courier',
    cancel: 'Cancel order',
    customerErrorMessage: 'Unable to display the order form',
    cancelDelivery: 'Cancel delivery',
    recipient: {
      title: 'Recipient and delivery details',
      label: {
        additionalStreetInfo: 'Address complement',
        address: 'Address',
        colivex: 'Delivery on Grave',
        contactName: 'Contact name',
        country: 'Country',
        companyName: 'Delivery location...',
        deceasedName: 'Name of deceased',
        deliveryDate: 'Delivery date',
        deliveryLocation: 'Delivery location...',
        deliveryMoment: 'Delivery moment',
        deliveryTime: 'Delivery time',
        event: 'Event',
        infos: 'Add. info',
        instructions: 'Instructions',
        name: 'Name',
        phone: 'Phone no.',
        postalCode: 'Postal code',
        prelimeryAgreement: 'Prelimery agreement', //not used in Italy
        region: 'Region',
        town: 'Town',
      },
    },
    order: {
      title: 'Order details',
      label: {
        legacyOrderId: 'Order id ISOWEB',
        orderStatus: 'Order status',
        orderDate: 'Order date',
        price: 'Price',
        deliveryCost: 'Delivery cost',
        trackingCode: `Shipping code`,
      },
      status: {
        NEW_ORDER: 'New order',
        ASSIGNED: 'Assigned',
        ACCEPTED: 'Accepted',
        REFUSED: 'Refused',
        ASSIGNATION_NOT_POSSIBLE: 'Assignation not possible',
        NOT_PRINTED: 'Not printed',
        PRINTED: 'Printed',
        IN_PROGRESS: 'In progress',
        INTERNAL_COURRIER: 'Internal courrier',
        EXTERNAL_COURRIER: 'External courrier',
        DELIVERED: 'Delivered',
        ABSENT: 'Absent',
        CANCELLED: 'Cancelled',
        SENT: 'Sent',
        REASSIGN: 'Reassigned',
      },
      notes: {
        addNote: 'Add note',
        addPhoto: 'Add a photo',
        anythingElse: 'Add your note',
        create: 'Create a note',
        delivery: 'Delivery',
        deliveryChanges: 'Delivery changes?',
        deliveryDetail: 'Specify delivery details',
        emptyNoteList: 'You have no notes',
        emptyPhotos: 'You have no photos',
        imageCategory: 'Image category',
        notValidatedNote: 'Impossible to update the status of this order',
        product: 'Product',
        title: 'Add notes',
        titleAddNotes: 'Add notes',
        titleSetAsDelivered: 'Validate a delivery',
        confirmSetAsDelivered: 'Are you sure you want to mark the {count} selected orders as delivered?',
        validatedNote: 'The note has been created',
        validatedOrderNote: 'The order has been validated',
        dragAndDrop: 'Drag and drop your image here',
        or: 'or',
        browseFiles: 'Browse files',
        uploadPhoto: 'Upload photo',
        addPhotoOptionnal: 'Add a photo (optional)',
      },
      delivery: {
        inProgress: {
          status: 'Delivery status:',
          momentTitle: 'Date & time: ',
          moment: '{date} - Between {hour} and {hourPlusOne}',
          price: 'Price:',
          from: 'by',
        },
        cancel: {
          title: 'Cancel delivery',
          body: 'This action will cancel the external delivery service assigned to this order.',
          bodyInternalDelivery: 'This action will cancel the internal delivery assigned to this order.',
          buttonSecondary: 'Abandon',
          buttonPrimary: 'Confirm',
        },
      },
      modifications: {
        title: 'Modified order details',
        tooltip: 'Click for updates',
        modalTitle: 'Updates',
        noChanges: 'Cannot display order modifications',
        markAsRead: 'Mark as read',
      },
      invoicePrintedLabel: {
        yes: 'Printed',
        no: 'Not printed',
      },
      invoicePrintedTooltip: {
        yes: 'Invoice printed',
        no: 'Invoice not printed',
      },
      recipientSmsStatus: {
        sent: {
          label: 'SMS sent',
          fullLabel: 'SMS sent',
          tooltip: 'A notification SMS has been sent to the recipient',
        },
        resent: {
          label: 'SMS resent',
          fullLabel: 'SMS resent',
          tooltip: 'The notification SMS has been resent to the recipient',
        },
        expired: {
          label: 'SMS expired',
          fullLabel: 'SMS expired',
          tooltip: 'The notification SMS has expired',
        },
        validatedByPhone: {
          label: 'Validated by phone',
          fullLabel: 'Validated by phone',
          tooltip: 'The florist validated the delivery by phone call',
        },
        validatedBySms: {
          label: 'Validated by SMS',
          fullLabel: 'Validated by SMS',
          tooltip: 'The recipient validated the delivery via the SMS link',
        },
      },
      recipientSmsAction: {
        removeValidation: 'Remove validation',
        resendSms: 'Resend SMS',
        validateByPhone: 'Mark validated by phone call',
      },
      recipientSmsActionHint: {
        temporaryUnavailable: 'Resending is temporarily unavailable',
        smsAlreadyResent: 'The SMS has already been resent',
      },
    },
    florist: {
      title: {
        executor: 'Executing florist',
        transmitter: 'Transmitter florist',
      },
      label: {
        name: 'Name',
        id: 'Identifiant',
        Phone: 'Phone no.',
        Email: 'Email',
        SecondEmail: 'Email',
      },
    },

    ribbon: {
      title: 'Ribbon',
      text: 'Ribon text: ',
    },

    buyer: {
      title: 'Buyer',
      label: {
        name: 'Name',
        phone: 'Phone no.',
        email: 'Email',
      },
    },

    header: {
      productCode: 'Product Code',
      quantity: 'Quantity',
      size: 'Size',
      description: 'Description',
      price: 'Price',
      image: 'Image',
      composition: 'Composition',
      moreProducts: 'More products',
      accessory: 'Accessories',
    },
    message: {
      title: 'Message card',
      label: {
        message: 'Message',
        signature: 'Signature',
      },
    },
    additionalImages: 'Saved photos',
    recipientNotes: {
      title: 'Recipient notes',
      cardTitle: 'Recipient note',
      cardTitleModified: 'New recipient note',
      canBeLeft: 'Order can be left unattended.',
      cannotBeLeft: 'Order cannot be left unattended.',
    },
  },

  // Transmissions
  transmission: {
    title: 'Order transmissions',
    new: 'New transmission:',
    locale: 'Local',
    abroad: 'Abroad',

    table: {
      no: 'No.',
      id: 'Order number',
      product: 'Product',
      recipient: 'Recipient',
      town: 'Town',
      status: 'Status',
      date: 'Date',
    },
    form: {
      deliveryAddressCemeteryWarning: `The delivery address appears to be a cemetery, but the 'Grave Delivery' option is not selected. Do you want to continue?`,
      cemetery: 'cemetery',
      sended: 'The form has been sent successfully',
      notSended: 'The form has not been sent',
      country: 'Country',
      mandatoryFields: 'Mandatory fields',
      noProductsForCountry: 'No products found for this country',
      freePrice: {
        title: 'Free price',
        low: 'Free price too low',
        entry: 'Enter a free price',
        from: 'Product with free price possible from',
        integer: `cents are not accepted by the international system`,
      },
      emailNotValid: 'Email not valid. example: %{email}',
      phoneNotValid: 'Phone not valid', //. example: %{phone}
      delivery: {
        additionalStreetInfo: 'Address complement',
        address: 'Address',
        addressComplement: 'Additional information',
        city: 'City',
        cityPostalCode: 'City or zip code',
        deliveryInstructions: 'Delivery instructions',
        extra: 'Extra',
        feasible: 'It is possible to make this order!',
        foreignAddress: `As foreign addresses cannot be verified, please enter the most complete address possible`,
        guarantee: '*Only Day is guaranteed',
        isBillNeeded: 'Need a bill',
        isCeremony: 'Is it for a ceremony?',
        no: 'No',
        notFeasible: 'No possible match for this order!',
        notFound: ' Address not found',
        place: 'Name of place',
        psm: 'Custom product information',
        slot: 'Delivery slot',
        streetName: 'Street name',
        streetNumber: 'Street number',
        title: 'Delivery',
        toGrave: 'Deliver to grave',
        yes: 'Yes',
        zipCode: 'Zip code',
        errorAddressAndLocality: `The address does not match the selected destination {locality} above`,
        date: {
          title: 'Delivery date',
          today: 'Today',
          tomorrow: 'Tomorrow',
          later: 'Later',
          selectedDate: 'Selected date: ',
        },
      },

      productDetail: 'Product',
      selectSize: 'Select size',
      orderType: {
        title: 'Order type',
        regular: 'Regular',
        funeral: 'Funeral',
      },
      contact: {
        additionalStreetInfo: 'Additional Info',
        address: 'Address',
        buyerTitle: 'Buyer detail',
        city: 'City',
        companyName: 'Company Name',
        contactTitle: 'Contact detail',
        deceased: 'Deceased',
        email: 'E-mail',
        firstName: 'First name',
        fiscalCode: 'Fiscal code',
        lastName: 'Last name',
        phone: 'Phone',
        title: 'Contact',
        zipCode: 'Zip code',
      },
      message: {
        title: 'Message card',
        message: 'Carte message',
        signature: 'Signature',
      },
      accessory: {
        addAccessory: 'Add accessory',
        addMoreAccessories: 'Add more accessories',
        changeAccessory: 'Change',
        label: 'Accessory',
        noAccessory: 'No accessory selected',
        removeAccessory: 'Remove',
        select: 'Select an accessory',
        title: 'Accessory',
        needRibbonText: 'Add a ribbon?',
        ribbonText: 'Enter the text for the ribbon',
      },
      summary: {
        title: 'Summary: ',
        productTotal: 'Product total:',
        accessoriesTotal: 'Accessories total:',
        deliveryCost: 'Delivery amount:',
        total: 'Total: ',
        transmissionFormComplete: 'Transmission form is complete',
        stepper: {
          productDetails: 'Product details',
          deliveryAddress: 'Delivery address',
          deliveryDate: 'Delivery date',
          feasability: 'Feasability',
          recipientInfo: 'Recipient informations',
          buyerInfo: 'Buyer informations',
          feasabilityOK: 'Feasability is OK',
        },
      },
      assignation: {
        title: 'Florist assignation',
        select: 'Please select the assignation type',
        zone1: 'Principale',
        zone2: 'Reserve',
        zone3: 'Big zone',
        displayZone3: 'Display list of ',
        automatic: 'Automatic',
        manual: 'Manual',
        floristNumber: 'Florist number',
        floristNumberError: `The member number format is not as expected`,
        floristNumberSupporting: 'The member number must start with 00',
        validationCode: 'Validation code',
        mandatoryValidationCode: 'Validation code Mandatory for this product',
        table: {
          floristName: 'Florist name',
          phone: 'Phone no.',
          distance: 'distance',
          quality: 'Quality Bonus',
        },
      },
      color: {
        select: 'Select a color',
        nbOfFlowers: 'Number of flowers',
        price: 'Price',
      },
      psp: {
        title: 'Payment',
        paymentOK: 'Payment successful! You can now proceed with the transmission.',
        paymentKO: 'Payment failed',
        paymentLinkExprired: 'The payment link has expired. Please generate a new one by selecting the payment type.',
        linkAlreadyExist:
          'It seems you have already generated a bank card payment link. Make sure the client will not use it again to avoid a duplicate payment.',
        linkTime: 'Time remaining before the payment link expires: {time}',
        paymentDone: 'Payment completed, the transmission will be automatically sent',
        selectPayment: {
          title: 'Select a payment type',
          cash: 'Cash',
          bankCard: 'Bank card',
        },
        paymentLink: {
          title: 'Choose how to send the payment link to the client',
          otherTab: 'Open in a new tab',
          sms: 'Send SMS',
          QrCode: 'Generate QR Code',
        },
        otherTab: {
          title: 'Payment link in another tab',
          explaination:
            'The payment page opens in a new tab for your client. We will notify you once the payment is completed or expired so you can proceed.',
        },
        sms: {
          title: 'Payment link via SMS',
          send: 'Send SMS',
          explaination:
            'A payment link has been sent to the client via SMS. We will notify you once the payment is completed or expired so you can proceed.',
          smsSendError: 'An error occurred while sending the SMS',
          smsSendImpossible: `Sending the SMS is not possible`,
          paymentLinkMessage: 'Interflora thanks you for your trust. Here is the link to pay for your order. ',
        },
        qrCode: {
          title: 'Payment link via QR code',
          explaination:
            'The client can scan the QR code to access the payment link. Once the payment is completed or expired, we will notify you so you can proceed with the transmission.',
        },
      },
    },
    quickCheck: {
      title: 'Check a destination',
      label: 'Select a destination',
      notFeasible: 'This destination is not available for forwarding.',
      feasible: `This destination is available for forwarding. 
Click on "Continue forwarding" to access the form.`,
      accessForm: 'Continue forwarding',
    },
  },

  // OrderList
  delivered: 'Delivered',
  absent: 'Absent',
  seeDetails: 'See details',
  hideDetails: 'Hide details',
  multiproducts: 'products',
  order: {
    search: 'What are you looking for?',
    searchTooltip: 'Use this button to search for an order',
    loadingOrders: 'Loading orders...',
    quickActions: {
      absent: 'Recipient absent',
      accept: 'Accept',
      acceptAndPrint: 'Accept and print',
      assignToCourier: 'Assign to courier',
      clear: 'Clear choices',
      delivered: 'Delivered',
      reassign: 'Reassign',
      refuse: 'Refuse',
      tooLate: 'Too late to accept',
      downloadCSV: 'Download CSV',
      print: 'Print',
      noOrderSelected: 'Select multiple orders to perform bulk actions',
      noOrderSelectedShort: 'No order selected',
      openToolbar: 'Open multi-selection',
      closeToolbar: 'Cancel multi-selection',
      ordersSelected: '{nbOrders} orders selected',
      acceptAll: 'Accept all selection',
      acceptAndPrintAll: 'Accept and print',
      cancelDelivery: 'Cancel delivery',
      feedback: {
        cancelDeliveryOK: `The external delivery has been successfully cancelled and the order has been moved to the orders tab.`,
        cancelInternalDeliveryOK: `The internal delivery has been successfully cancelled and the order has been moved to the Orders tab.`,
        cancelDeliveryKO: `Unable to cancel the external delivery.`,
        cancelInternalDeliveryKO: `It is not possible to cancel an internal delivery.`,
      },
    },
    title: 'Orders list',
    noStatusBanner: {
      mainText: `{count} order whose delivery slot end is approaching does not have the status "Delivered" or "Recipient absent". | {count} orders whose delivery slot end is approaching do not have the status "Delivered" or "Recipient absent".`,
      subText: `Behind each order, someone is waiting to know if their flowers arrived safely. Have you thought about updating them?`,
    },
    table: {
      no: 'No.',
      deliveryDate: 'Delivery date',
      deliveryTime: 'Delivery time',
      id: 'Order number',
      product: 'Product',
      price: 'Price',
      town: 'Town',
      recipient: 'Recipient',
      preparing: 'In progress',
      invoice: 'Invoices',
      actions: 'Actions',
      deliveryService: 'Delivery service',
      reason: 'Reason',
      openDetail: 'Open detail',
      closeDetail: 'Close detail',
      deliveryDetails: 'Delivery details',
      address: 'Address',
      phone: 'Phone number',
      goToOrderDetail: 'Go to order detail page',
      instructions: 'Delivery instructions',
    },
    modal: {
      refuse: {
        title: 'Do you want to refuse this order?',
        reason: {
          reason1: 'Price is too low',
          reason2: 'My shop is closed',
          reason3: `I can't delivered`,
          reason4: `I haven't this product`,
        },
      },
      absent: {
        title: `Why couldn't the order be delivered?`,
        subtitle: `Why couldn't the order be delivered?`,
        reason: {
          DANOREP: 'Recipient unreachable',
          DADATEULT: 'Recipient changed the delivery date',
          DAREFUS: 'Recipient refused the order',
          DANOINFO: 'Missing information to deliver the order',
        },
      },
      reassign: {
        title: 'Do you want to reassign this order?',
        reason: {
          PCO: 'Missing required colors',
          PFO: 'Missing required flowers',
          PL: 'No delivery person available',
          LL: 'Delivery too far',
          RT: 'Received too late',
          PAM: 'No more stock in store',
        },
      },
      delivery: {
        title: 'Choose a delivery service',
        intro: 'Please select a delivery service for order <b>{orderId}</b>.',
        introMultiOrders: 'Please select a delivery service for the {count} orders.',
        deliveryCost:
          'Cost {deliveryService}({serviceAmount}) - Delivery charge({itfAmount}) = Out of pocket({totalPrice})',
        delay: 'Available in {noticePeriod}',
        availableImmediately: 'Available immediately',
        includedDeliveryPrice: 'Included in your delivery package',
        serviceUnavailable: 'Service unavailable',
        selectYourSlot: 'Choose the slot',
        deliverOrder: 'Deliver the order {orderId}',
        deliveryInstructions: 'Anything to make delivery easier',
        validated: `Order {orderId} is sent to {service} !\nCheck delivery status on delivery tab`,
        internalValidated: `The order is assigned to {username} and is moved to the delivery tab.`,
        internalMultipleOrdersValidated: `Orders are assigned to {username} and moved to the delivery tab.`,
        errorOnValidation: 'Unable to create delivery for order {orderId}',
        errorOnMultipleOrdersValidation: 'Unable to create a delivery for the orders.',
        dateTooFar: `The proposed delivery date is too far away. Please try again in a few days.`,
      },
    },
    multiSelect: {
      delivered: {
        allDelivered:
          '{count} orders have been successfully marked as delivered. They are now moved to the order history.',
        someNotUpdated: 'Some of your orders could not be updated.',
        noneUpdated: 'None of your selected orders have changed status.',
      },
      accept: {
        all: '{count} orders have been successfully accepted. They are now moved to the orders tab.',
        someNotUpdated: 'Some of your orders could not be accepted.',
        noneUpdated: 'None of the selected orders have been accepted.',
        waiting: 'Processing in progress, please wait...',
      },
    },
    floristToggle: {
      changeStateTooltip: 'Change order status',
      backToInitial: 'Back to initial status',
      initial: {
        label: 'Initial',
      },
      inProgress: {
        label: 'In progress',
      },
      ready: {
        label: 'Bouquet ready',
        lockedHint: 'Available only 2 hours before the delivery slot',
      },
    },
  },

  // pager
  pager: {
    itemsPerPage: '{counter} / page',
  },

  // My page
  myPage: {
    title: 'My page',
    calendarManagement: 'Calendar management',
    infoManagement: 'Info management',
    notFound: 'Florist information not found',
    accessories: {
      accessoriesAction: 'Availability',
      accessoriesList: 'Accessories list',
      anyAccessory: 'No accessories',
      title: 'Accessories Management',
    },
    hours: {
      title: 'Open hours',
      changeOpeningHours: 'Change your opening hours',
      closeAllDayButton: 'Close all day',
      shopClosed: 'Your shop is closed this day',
      openButton: 'Open',
      addBreak: 'Add a break',
      removeBreak: 'Remove the break',
      saveButton: 'Save',
      closingTime: 'Closing time',
      openingTime: 'Opening time',
      breakEnd: 'Break End',
      breakStart: 'Break start',
    },
    exceptions: {
      headerTitle: 'My exceptions',
      the: 'The:',
      from: 'From:',
      new: 'Add an exception',
      next: 'Next exceptions',
      any: 'Any exception',
      title: 'Next exceptions',
      to: 'To:',
    },

    calendar: {
      title: 'Monthly overview',
      weeklyCalendar: {
        calendarModified: 'Your calendar has been successfully modified',
        clickToChange: 'Click to open or close*',
        closed: 'Closed',
        closedAM: 'Closed in the morning',
        closedPM: 'Closed in the afternoon',
        editWeek: 'Edit your weekly schedule',
        open: 'Open all day',
        openAM: 'Open in the morning',
        openPM: 'Open in the afternoon',
        title: 'Weekly calendar',
      },
      massive: {
        title: 'Add massive exceptions',
        years: 'Years',
        months: 'Months',
        days: 'Days',
        morning: 'Morning',
        afternoon: 'Afternoon',
        exceptionsSended: 'Exceptions sent successfully',
        exceptionsNotSended: `Exceptions cannot be logged`,
      },
    },

    quality: {
      bonus: 'Quality bonus',
      note: 'Your rating',
      noteMini: 'Minimum rating',
      noteMaxi: 'Maximum rating',
      endPeriod: 'End of validity',
      explainationTitleToMM: 'My Quality Bonus and My Reassignments',
      explainationToMM: `The sections "My Quality Bonus" and "My Reassignments" are not yet available on Iris.
By clicking the corresponding buttons, you will be redirected to Mon magasin, where they are accessible.`,
      claims: {
        deliveryDate: 'Date',
        orderId: 'Order Number',
        productCode: 'Product',
        reason: 'Reason',
        explainationTitleToMM: 'The "My Performance Tracking" page is under construction',
        explainationToMM: 'It will soon gather all your key metrics in a complete and improved dashboard.',
      },
      title: {
        general: 'General',
        advertissement: 'Advertising / Brand Promotion',
        quality: 'Service Quality',
        availability: 'Availability',
        tools: 'Tools',
      },
    },
    noStock: 'No stock',
    supplies: {
      title: 'Supplies',
      seeCart: 'View and confirm my order',
      yourOrders: 'Your orders',
      emptyCart: 'Empty cart',
      chooseSupplies: 'Choose supplies',
      modifyChooseSupplies: 'Modify and choose supplies',
      orderSupplies: 'Supply orders',
      explainationTitleToMM: 'Your supply orders are coming soon to IRIS',
      explainationToMM: `The sections "Supply Orders" and "My Supply Orders" are not yet available on IRIS.
By clicking the corresponding buttons, you will be redirected to Mon magasin, where you can view and manage your supply orders.`,
      modal: {
        add: 'Add',
        freeArticles: 'Administrative (free)',
        paidArticles: 'Technical - Interflora (paid)',
        productCode: 'Reference',
        image: 'Preview',
        label: 'Label',
        VTACode: 'VAT Code',
        price: 'Unit Price',
        action: 'Action',
      },
      panel: {
        cart: 'My cart',
        emptyCart: 'Your cart is empty',
        total: 'Total : ',
        noOrders: 'You have no orders',
      },
    },
    contact: {
      mail: 'Your email',
      mail2: 'Your secondary email',
      validationCode: 'Your validation code',
      address: 'Your address',
      phone: 'Your phone number',
    },
    networkContact: {
      title: 'Your network animator',
      mail: 'Their email',
      name: 'Their name',
      phone: 'Their phone number',
      phoneAppointment: 'Book a phone appointment',
    },
    exclusions: {
      title: 'My exclusions',
      list: 'My exclusions list',
      empty: 'You have no exclusions',
    },
    claims: {
      title: 'My Claims',
      empty: 'Congratulations! You have no recorded claims in the past 12 months',
    },
    reassignations: {
      title: 'My reassignments',
      empty: 'You have no recorded reassignments in the past 6 months',
    },
  },

  info: {
    addHolidaysKO: 'Unable to add this closing period',
    addHolidaysOK: 'Closed period added',
    delHolidaysKO: 'Unable to delete this closing period',
    delHolidaysOK: 'Closed period deleted',
    documentKO: 'Unable to view this document',
    documentOK: 'The document was opened in another window',
    pending: 'Demand in progress',
    documentPending: 'Current document opening, please wait',
    editField: 'edit field',
    nophone: 'Please add a phone number',
    nosecondMail: 'Please add an e-mail',
    nopersonalCode: 'Please add a personal code',
    statusKO: 'Unable to update status',
    statusOK: 'Status updated',
    updatePersonalCodeKO: 'Unable to update the personal code',
    updatePersonalCodeOK: 'Personal code updated',
    updatePhoneKO: 'Unable to update the phone',
    updatePhoneOK: 'Phone updated',
    updateSecondEmailKO: 'Unable to update the email',
    updateSecondEmailOK: 'Email updated',
    updateStockKO: 'Unable to update stock',
    updateStockOK: 'Stock updated',
    postSupplyOK: 'Order sent',
    postSupplyKO: 'Order failed',
    duplicateHolidays: 'A closure is already scheduled for this period.',
    photoUploadOK: 'Photo saved',
    photoUploadKO: `Unable to save photo`,
    photoUploadTooBig: `The photo is too large.
Please upload a photo smaller than 5MB.`,
    reassignOK: 'Order reassigned, you will be redirected to the order list',
    reassignKO: 'Reassignment failed',
  },

  days: {
    initiale: { 1: 'M', 2: 'T', 3: 'W', 4: 'T', 5: 'F', 6: 'S', 0: 'S' },
    short: { 1: 'Mon', 2: 'Tue', 3: 'Wed', 4: 'Thu', 5: 'Fri', 6: 'Sat', 7: 'Sun' },
    0: 'Monday',
    1: 'Tuesday',
    2: 'Wednesday',
    3: 'Thursday',
    4: 'Friday',
    5: 'Saturday',
    6: 'Sunday',
  },
  moment: {
    0: 'Morning',
    1: 'Afternoon',
    2: 'Day',
    3: 'Evening',
    hour: {
      0: '',
      1: '',
      2: '',
      3: '',
    },
  },
  openingMoment: {
    0: 'Closed all day',
    1: 'Open only the morning',
    2: 'Open only the afternoon',
    3: 'Open whole day',
    4: 'Public holiday',
    5: 'Regional holiday',
    6: 'Mandatory opening day',
  },
  dropdown: {
    label: {
      accessory: 'Choose your accessory',
      bouquet: 'Choose the bouquet',
      city: 'Enter the city',
      country: 'Choose country',
      loginAs: 'Enter florist code',
      mail: 'Enter your e-mail',
      messageContent: 'Enter your message',
      noteCategory: 'Note category',
      photoCategory: 'Photo category',
      occasion: 'Choose occasion',
      receiveAnswerAt: 'You will receive the answer at',
      select: 'Choose the reason',
      selectCategory: 'Select category',
      time: 'Choose time of day',
      type: 'Choose the type',
      year: 'Choose the year',
      search: 'Search...',
      locality: 'Choose the destination',
    },
    code: {
      ALL: 'All',

      // OBJECT OF THE MESSAGE
      CANCEL: 'I would like to cancel my order',
      INFO: 'I need information to process an order',
      HELP: ' Iris assistance',
      SUPPLY: 'Supply order',
      QUALITY: 'Quality bonus',
      SHOP1: 'Your shop (disposal/termination/new contact details)',
      SHOP2: 'Your shop (accessories/signboard)',
      CALL: 'Call request from a salesperson',
      INDEMNITY: 'Questions about your compensation statement',
      CLAIM: 'Claims/disputes',
      B2B: 'Business orders B2B',

      // MOMENT
      0: 'Morning',
      1: 'Afternoon',
      2: 'Day',
      AFTERNOON: 'Afternoon',
      DAY: 'Day',
      MORNING: 'Morning',

      // EVENT
      BABY: 'New baby',
      BIRTHDAY: 'Birthday',
      CONGRATULATIONS: 'Congratulations',
      FUNERALS: 'Funerals',
      JUSTBECAUSE: 'Just because (pour le plaisir)',
      OTHER: 'Other reason',
      WEDDING: 'Wedding',
      WELLSOON: 'Get well soon',

      // MAIL REASONS
      ADMIN: 'Question about my administration',
      HARDWARE: 'Question about problem on PC',
      INVOICEINCIDENT: 'Invoice incident',
      ORDER: 'Question about an order',
      ORDERINCIDENT: 'Order incident',
      ORDERMATERIAL: 'Material order',
      PARTNER: 'Question about my partnership',
      SUGGESTION: 'Make a suggestion',

      // DOCUMENTS
      IT_DOC_ORDER_CART: 'Order cart',
      IT_DOC_ORDER_RECEIVER: 'Order receiver',
      IT_DOC_ORDER_SENDER: 'Customer purchase order',
      IT_INVOICE_BALANCE: 'Balance invoice(2024)',
      IT_INVOICE_PURCHASE: 'Purchase invoice(2024)',
      IT_INVOICE_VENDOR: 'Vendor invoice(2024)',
      SP_INVOICE_COMMISSIONS_RECTIFY: 'Commission adjustment invoice',
      SP_INVOICE_COMMISSIONS: 'Purchase fee/comission invoices for florists',
      SP_INVOICE_EXECUTIONS_RECTIFY: 'Corrective purchase invoices of executions',
      SP_INVOICE_EXECUTIONS: 'Purchase execution invoices',
      SP_INVOICE_EXTRACT: 'Summary Clearing document',
      SP_INVOICE_MATERIAL: 'Material invoice',
      SP_INVOICE_QUOTAS: 'Sales florist monthly invoice fees/ Corrective invoices',
      SP_INVOICE_CSI_SALES: 'Invoice (completed orders)',
      SP_INVOICE_QUOTAS_RECTIFY: 'Rectified billing quotas',
      PT_SAFT: 'Rectified billing quotas',
    },
  },

  notification: {
    title: 'Notifications',
    label: {
      order: 'new order',
      orderPlural: 'new orders',
      transmission: 'transmission',
      transmissionPlural: 'transmissions',
      review: 'review',
      reviewPlural: 'reviews',
      modification: 'modification',
      modificationPlural: 'modifications',
      cancellation: 'cancellation',
      cancellationPlural: 'cancellations',
      refused: 'refused order',
      refusedPlural: 'refused orders',
      expired: 'expired order',
      expiredPlural: 'expired orders',
    },
    message: {
      hideNotification: 'Hide notification',
      more: 'See more',
      orderPlural: 'See order list',
      transmissionPlural: 'See transmissions list',
      reviewPlural: 'See reviews',
      modificationPlural: 'See order list',
      cancellationPlural: 'Hide notification',
      refusedPlural: 'Hide notification',
      expiredPlural: 'Hide notification',
    },
    markAllAsRead: 'Mark all as read',
  },

  mail: {
    from: 'Message from florist: ',
    subject: 'Subject: ',
    body: 'Message: ',
    sended: 'Email sent',
    notSended: 'Error sending email',
  },

  billing: {
    notAllowed: 'You are not authorized to see this information',
    header: {
      id: 'Number',
      date: 'Date',
      numberOfTransmission: 'Number of transmissions',
      amount: 'Amount',
      type: 'Type',
      file: 'File',
    },
  },
  filter: {
    all: 'All',
    today: 'Today',
    tomorrow: 'Tomorrow',
    later: 'Later',
    past: 'Past',
    toPrepare: 'Orders',
    inDelivery: 'Delivery',
    absent: 'Absent',
    toAccept: 'To be accept',
    inProgress: 'In progress',
    late: 'Late',
    delivered: 'Delivered',
    activity: 'My activity',
    financial: 'My compensations',
    profiles: 'My couriers',
    activCourier: 'Active couriers',
    inactivCourier: 'Inactive couriers',
    allCourier: 'All couriers',
    legal: 'Legal documents',
    manageStore: 'Manage my store',
    bonus: 'Quality Bonus',
    customer: 'Customer order form',
    executingForm: 'Executing order form',
    IT_DOC_ORDER_CART: 'Order cart',
    IT_DOC_ORDER_RECEIVER: 'Order receiver',
    IT_DOC_ORDER_SENDER: 'Customer purchase order',
    IT_INVOICE_BALANCE: 'Balance invoice(2024)',
    IT_INVOICE_PURCHASE: 'Purchase invoice(2024)',
    IT_INVOICE_VENDOR: 'Vendor invoice(2024)',
    SP_INVOICE_COMMISSIONS_RECTIFY: 'Commission adjustment invoice',
    SP_INVOICE_COMMISSIONS: 'Purchase fee/comission invoices for florists',
    SP_INVOICE_EXECUTIONS_RECTIFY: 'Corrective purchase invoices of executions',
    SP_INVOICE_EXECUTIONS: 'Purchase execution invoices',
    SP_INVOICE_EXTRACT: 'Summary Clearing document',
    SP_INVOICE_MATERIAL: 'Material invoice',
    SP_INVOICE_QUOTAS: 'Sales florist monthly invoice fees/ Corrective invoices',
    SP_INVOICE_CSI_SALES: 'Invoice (completed orders)',
    SP_INVOICE_QUOTAS_RECTIFY: 'Rectified billing quotas',
    PT_SAFT: 'Saft',
  },

  size: {
    label: 'Select size',
    0: 'Unique price',
    1: 'Small',
    2: 'Large',
    3: 'Extra large',
    4: 'Free price',
    Standard: 'Standard',
    Premium: 'Premium',
    Deluxe: 'Deluxe',
    one_size: 'Unique price',
    small: 'Small',
    medium: 'Large',
    large: 'Extra large',
    null: 'Depending on the price',
    Normal: 'Small',
    Grande: 'Large',
    Superior: 'Extra large',
    Pequeño: '',
    Médio: '',
    Médium: 'Large',
    Petit: 'Small',
  },

  deliveryMode: {
    CEREMONY: 'Ceremony',
    NO_ADDRESS: 'No addresse',
    SELF: 'Self',
    STANDARD: 'Standard',
    TOMB: 'Funeral',
    FUNERAL_PLACE: 'Funeral',
    GRAVE: 'Funeral',
  },

  error: {
    floristUnknown: {
      title: 'Unknown login',
      body: 'The current account is invalid: please click on the logout button and choose another account.',
      button: 'Log out',
    },
    noCountryCode: {
      title: 'Unknown country code',
      body: 'Unknown country code: please click on the logout button and choose another account.',
      button: 'Log out',
    },
  },

  soon: {
    kpi: 'Coming soon, find your business KPIs here',
    hourly: 'Coming soon, find your opening hours here',
  },

  color: {
    blue: 'Blue',
    green: 'Green',
    mixed: 'Multicolor',
    orange: 'Orange',
    pink: 'Pink',
    purple: 'Purple',
    red: 'Red',
    silver: 'Silver',
    white: 'White',
    yellow: 'Yellow',
  },

  QrCode: {
    200: 'The order is delivered',
    400: 'You cannot set the order status to delivered',
    500: 'An error has occurred, please contact Interflora',
  },

  internalUser: {
    any: 'No florist selected',
    login: 'Login',
    needId: 'You must be connected to a florist to see this information',
    placeholder: 'Enter florist code',
    title: 'Login as',
    loggedIn: 'You are logged in as',
    backToAdmin: 'Back to the administrator area',
  },

  // DELIVERY STATUSES
  deliveryStatus: {
    scheduled: 'Scheduled',
    booked: 'Booked',
    pending: 'Looking for driver',
    picking: 'Picking',
    almost_picking: 'Almost picking',
    waiting_at_pickup: 'Waiting at pickup',
    delivering: 'Delivering',
    almost_delivering: 'Almost delivering',
    waiting_at_dropoff: 'Waiting at dropoff',
    delivered: 'Delivered',
    no_courier_available: 'No courier available',
    cancelled: 'Cancelled',
  },

  calendarExceptionType: {
    CountryForceOpen: 'Mandatory opening',
    CountryHolidays: 'country holidays',
    DefaultDates: 'Open',
    FloristCloseOnlyAfternoon: 'Closed only afternoon',
    FloristCloseOnlyMorning: 'Closed only morning',
    FloristHoliday: 'Holidays',
    FloristOpenOnlyAfternoon: 'Open only afternoon',
    FloristOpenOnlyMorning: 'Open only morning',
    FloristOpenWholeDay: 'Open',
    RegionalHoliday: 'Regional holiday',
  },

  month: {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
  },
  lastsMonth: 'Last 12 months',
  kpi: {
    labelBestSeller: 'Number of sales',
    labelExecution: 'Executions amount',
    labelNPS: 'NPS',
    labelNumberOfRefusal: 'Number of refusals',
    thisMonth: 'This month',
    titleBestSeller: 'Your best sellers',
    titleExecution: 'My executions',
    tooltipExecution: 'Number of executions',
    noDataPeriod: 'No data for this period',
    month: {
      0: 'Jan',
      1: 'Feb',
      2: 'Mar',
      3: 'Apr',
      4: 'May',
      5: 'Jun',
      6: 'Jul',
      7: 'Aug',
      8: 'Sep',
      9: 'Oct',
      10: 'Nov',
      11: 'Dec',
    },
  },

  locality: {
    FR: 'France Métropolitaine',
    CORSE: 'Corse',
    DOMTOM: 'Drom-Com',
  },

  compensation: {
    explanation: '',
    title: 'My compensation for ',
    fortnight: {
      1: '1st fortnight',
      2: '2nd fortnight',
    },
    login: {
      title: 'Restricted access',
      secretCode: 'Secret code:',
      placeholder: '12345',
      error: 'Incorrect secret code',
    },
    recette: {
      download: 'Download results from',
    },
  },

  capping: {
    title: `Execution capacity`,
    adjustCapping: 'Adjust capping limit',
    daysBeforeEvent: `The event is in {count} day{plural}`,
    needToBeSuperior: `During this period, it is not possible to reduce the capping below {minCapping}. Please adjust the value.`,
    ordersLeft: `{ordersLeft} orders left before reaching the capping limit! You may consider increasing the maximum capping limit.`,
    noOrdersLeft: `You have reached your maximum execution capacity. You may consider increasing the maximum cap limit.`,
  },

  xlPage: {
    productsStock: {
      action: 'Availability',
      list: 'Products list',
      anyProduct: 'No products',
      title: 'Products Management',
      selection: {
        flower: 'Flowers',
        gift: 'Gifts',
      },
    },
  },

  internalCourier: {
    createNewCourier: 'Add a courier',
    undefined: 'Not defined',
    list: {
      headerTable: {
        courierProfile: 'Courier',
        courierId: 'Courier ID',
        activationDate: 'Activation date',
        deactivationDate: 'Deactivation date',
        actions: 'Actions',
      },
      statusSrOnly: {
        active: 'Active courier profile',
        inactive: 'Inactive courier profile',
      },
      toggleStatus: {
        active: 'Activate profile',
        inactive: 'Deactivate profile',
      },
      edit: 'Edit profile',
      empty: {
        title: 'No delivery driver profile has been created yet.',
        text: 'Delivery driver profiles allow you to assign orders to your in-house delivery drivers.',
      },
    },
    create: {
      couriersInformation: 'Courier information',
      title: 'Create a courier profile',
      name: 'Courier name*',
      nameAlreadyExistMessage: 'This name is already taken. Add something (e.g. a number) to make it unique.',
      id: 'Courier login identifier',
      idExplaination:
        'The identifier allows this profile to log in to Iris. It is automatically created from the name entered and your shop information to be unique.',
      profileCreated: 'The courier has been created.',
      profileNotCreated: 'Unable to create the courier',
      password: {
        label: 'Password*',
        confirmLabel: 'Confirm password*',
        confirmNotMatch: 'The two fields do not match.',
        rules: {
          uppercase: 'One uppercase letter',
          lowercase: 'One lowercase letter',
          number: 'One number',
          minCaracters: 'More than 10 characters',
          specialCaracters: "One special character among ? ! - _ & % {'@'}",
        },
      },
      status: {
        title: 'Courier status',
        explanation: {
          activation: {
            default: `The courier will be active from the selected activation date.`,
            inactiv: 'The courier will be inactive.',
          },
          desactivation: {
            default: `The courier will be inactive from the selected deactivation date.`,
            notDefine: `The courier will remain active until you deactivate it.`,
          },
          tomorrowTooltip: `The deactivation date cannot be earlier than the activation date.`,
        },
      },
      date: {
        activationTitle: `Activation date*`,
        desactivationTitle: 'Deactivation date*',
        today: `Today`,
        tomorrow: 'Tomorrow',
        otherDate: 'Other date',
        notDefine: 'Not defined',
        endDateBeforeStartDate: 'The deactivation date cannot be earlier than the activation date.',
      },
      error: {
        someFieldsNeedCorrection: 'Some information needs to be corrected. Please check the highlighted fields.',
        someFieldsAreMissing: 'Some information is missing. Please check the highlighted fields.',
        fieldRequired: 'This field is required.',
        impossibleToCreate: 'Unable to create the courier profile.',
      },
    },

    update: {
      title: 'Edit a courier profile',
      profileUpdated: 'The courier has been updated.',
      selectedCourier: 'The selected delivery driver',
      cancelButton: 'Keep planning',
      activationButton: 'Activate',
      deactivationButton: 'Deactivate',
      password: {
        edit: 'Edit password',
        label: 'New password*',
        closeWithoutSaving: 'Close without saving',
      },
      error: {
        impossibleToUpdate: 'Unable to update the courier profile.',
      },
      guidingMessage: {
        activation: 'It appears that an activation has already been scheduled for this mail!',
        deactivation: 'It appears that this mail has already been scheduled for deactivation!',
        activationDate: 'Planned activation date:',
        deactivationDate: 'Planned deactivation date:',
        profileDeactivate: 'The courier has been successfully deactivated',
        profileActivate: 'The courier has been successfully activated',
        disableActions:
          'To change the working period or remove this delivery driver, you must first remove the orders associated with them.',
      },
      modalTitle: {
        deactivation: 'Deactivate the delivery driver',
        activation: 'Activate the delivery driver',
      },
    },
    delete: {
      title: 'Delete a courier profile',
      button: 'Delete this courier',
      bodyTitle: 'Are you sure you want to permanently delete this courier?',
      profileDeleted: 'The courier has been successfully deleted.',
      error: {
        impossibleToUpdate: 'Unable to delete the courier profile',
        activeOrders:
          'This delivery driver still has active orders in progress. Cancel or reassign these orders from the Delivery tab, then try again.',
      },
    },
    deliveryTab: {
      isActiv: 'Internal',
      isInactiv: 'Inactive courier',
    },
    assignation: {
      title: 'Internal delivery',
      activeProfiles: '{n} active profile on delivery day',
      activeProfilesPlural: '{n} active profiles on delivery day',
      noActiveProfiles: 'No active delivery drivers',
      goToInternalCourierList: 'Open the courier management section',
    },
    detail: 'Order handled internally',
  },
};
